import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { PostInterventionOrderBody } from 'src/interfaces/api/InterventionOrder';
import { Checkbox, FormControlLabel, Grid, InputAdornment, TextField } from '@material-ui/core';
import AddressFields from './components/AddressFields';
import { createUseStyles } from 'src/theming';
import { Skeleton } from '@material-ui/lab';

const useStyles = createUseStyles({
  checkboxes: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > *': {
      marginBottom: 0,
    },
  },
});

interface Props {
  ticketLoading?: boolean;
  isSiteReadOnly?: boolean;
}

const InformationSection: FC<Props> = ({ ticketLoading, isSiteReadOnly }) => {
  const classes = useStyles();

  const { control } = useFormContext<PostInterventionOrderBody>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Controller
          name='socialReason'
          control={control}
          rules={{ required: { value: !isSiteReadOnly, message: 'Le champ est requis' } }}
          render={({ field: { value, ...others }, fieldState: { error } }) =>
            ticketLoading ? (
              <Skeleton height={56} />
            ) : (
              <TextField
                {...others}
                value={value || ''}
                label='Raison sociale'
                variant='outlined'
                fullWidth
                disabled={isSiteReadOnly}
                error={undefined !== error}
                helperText={error?.message}
              />
            )
          }
        />
      </Grid>

      <Grid item xs={12}>
        <AddressFields readOnly={isSiteReadOnly} loading={ticketLoading} />
      </Grid>

      <Grid item xs={12} sm={7} md={8}>
        <Controller
          name='price'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label='Tarif'
              InputProps={{
                endAdornment: <InputAdornment position='end'>€ H.T.</InputAdornment>,
              }}
              variant='outlined'
              type='number'
              fullWidth
              error={undefined !== error}
              helperText={error?.message}
            />
          )}
        />
      </Grid>

      <Grid item className={classes.checkboxes} xs={12} sm={5} md={4}>
        <Controller
          name='hasContract'
          control={control}
          render={({ field: { value, ...field } }) => (
            <FormControlLabel
              control={<Checkbox />}
              label='Contrat'
              checked={value}
              labelPlacement='start'
              {...field}
            />
          )}
        />

        <Controller
          name='toBilled'
          control={control}
          render={({ field: { value, ...field } }) => (
            <FormControlLabel
              control={<Checkbox />}
              label='À&nbsp;facturer'
              checked={value}
              labelPlacement='start'
              {...field}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default InformationSection;
